<template>
  <div>
    <section
      :class="[
        'footer',
        {
          'footer--hidden': routeCheck,
        },
      ]"
    >
      <ProgressBar />
      <div class="footer__inner">
        <div class="footer__controls" v-if="!hideNavigation">
          <div
            :class="[
              'footer__control',
              'back',
              'first-last',
              {
                'footer__control--disabled':
                  activeDataList.length === 0 || activeIndex === 0,
              },
            ]"
            @click="first"
          >
            <SvgControl /><SvgControl />
          </div>
          <div
            :class="[
              'footer__control',
              'back',
              {
                'footer__control--disabled':
                  activeDataList.length === 0 || activeIndex === 0,
              },
            ]"
            @click="prev"
          >
            <SvgControl />
          </div>
          <div
            :class="[
              'footer__control',
              {
                'footer__control--disabled':
                  activeDataList.length === 0 ||
                  activeIndex === activeDataList.length - 1,
              },
            ]"
            @click="next"
          >
            <SvgControl />
          </div>
          <div
            :class="[
              'footer__control',
              'first-last',
              {
                'footer__control--disabled':
                  activeDataList.length === 0 ||
                  activeIndex === activeDataList.length - 1,
              },
            ]"
            @click="last"
          >
            <SvgControl /><SvgControl />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Footer',

  props: {
    hideNavigation: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['activeDataList', 'activeCard', 'activeIndex']),

    routeCheck() {
      return (
        ['landing', 'style-guide', 'mechanism', 'recombinant'].includes(this.$route.name)
      );
    },
  },

  components: {
    SvgControl: () => import('@/assets/svgs/control.svg?inline'),
    ProgressBar: () => import('./ProgressBar.vue')
  },

  methods: {
    ...mapActions(['getActiveCard', 'updateActiveIndex']),

    async next() {
      if (this.activeIndex < this.activeDataList.length - 1) {
        await this.updateActiveIndex(this.activeIndex + 1);
        this.getActiveCard(this.activeDataList[this.activeIndex]);
      }
    },

    async prev() {
      if (this.activeIndex > 0) {
        await this.updateActiveIndex(this.activeIndex - 1);
        this.getActiveCard(this.activeDataList[this.activeIndex]);
      }
    },

    async first() {
      await this.updateActiveIndex(0);
      this.getActiveCard(this.activeDataList[0]);
    },

    async last() {
      await this.updateActiveIndex(this.activeDataList.length - 1);
      this.getActiveCard(this.activeDataList[this.activeDataList.length - 1]);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #e8e8e8;
  height: rem(80);
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;

  &--hidden {
    bottom: rem(-80);
  }

  @include flexbox(flex-end, flex-end);

  &__inner {
    height: rem(70);
    width: inherit;
    background: $footerInnerBG;
    @include flexbox(center, center);
  }

  &__controls {
    @include flexbox(center, flex-start);
    padding-left: rem(150);
    color: $white;

    svg {
      height: rem(20);
      width: rem(20);
    }
  }

  &__control {
    height: rem(70);
    width: rem(70);
    border-right: 1px solid #e8e8e8;
    @include flexbox(center, center);
    cursor: pointer;
    transition: $transition;


    &.back {
      svg {
        transform: rotateZ(180deg);
      }
    }

    &.first-last {
      svg {
        height: rem(10);
        width: rem(10);
        position: relative;
        &:first-child {
          left: rem(3)
        }
        &:last-child {
          right: rem(3)
        }
      }
    }

    &:first-child {
      border-left: 1px solid #e8e8e8;
    }

    &--disabled {
      background: darken($footerInnerBG, 20%);
      color: rgba(255,255,255, 0.3);
      pointer-events: none;

      svg {
        opacity: 0.4;
      }
    }
  }
}
</style>
